import React from 'react'
import classNames from 'classnames'
import BitcoinIcon from '@/icons/bitcoin-filled'

/** Display every bid in BTC, preserving satoshi precision. */
export default function BidAmount({
	sats,
	className,
	iconClassName = 'size-3'
}: {
	sats: number
	className?: string
	iconClassName?: string
}) {
	const value = (sats / 1e8).toLocaleString('en-US', { maximumFractionDigits: 8 })
	return (
		<span className={classNames('inline-flex min-w-0 items-center gap-1 tabular-nums', className)}>
			<BitcoinIcon className={classNames('shrink-0', iconClassName)} />
			<span className="truncate">{value}</span>
		</span>
	)
}
